var _path, _path2, _path3, _g, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalService(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.385 52.165C21.0088 52.1652 18.5971 50.5487 18.2506 50.3074C11.9343 45.9978 8.16406 38.871 8.16406 31.2415C8.16406 25.0777 10.5677 19.2828 14.9322 14.9244C19.2968 10.5659 25.0997 8.16553 31.2721 8.16553C35.3051 8.16553 39.2754 9.21879 42.754 11.2115C46.1273 13.1438 48.9818 15.918 51.009 19.2342C51.2815 19.68 51.1405 20.2619 50.6941 20.534C50.2477 20.8062 49.6651 20.6653 49.3925 20.2196C47.5309 17.1742 44.9094 14.6265 41.8117 12.852C38.6194 11.0234 34.9749 10.0568 31.272 10.0568C25.6054 10.0568 20.2781 12.2605 16.2714 16.2616C12.2646 20.263 10.058 25.5829 10.058 31.2415C10.058 38.2471 13.5214 44.7916 19.3228 48.7483C19.3256 48.7502 19.3284 48.7521 19.331 48.754C20.2143 49.3669 22.8468 50.7998 24.388 50.0733C24.861 49.8501 25.4253 50.0522 25.6487 50.5245C25.8719 50.9967 25.6696 51.5604 25.1968 51.7833C24.6201 52.0554 24.0036 52.165 23.385 52.165Z",
    fill: "url(#paint0_linear_7176_39779)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7941 28.0758C34.7941 31.7661 31.7983 34.7577 28.1029 34.7577H15.6247C11.9293 34.7577 8.93359 31.7661 8.93359 28.0758V15.615C8.93359 11.9247 11.9293 8.93311 15.6247 8.93311H28.1029C31.7983 8.93311 34.7941 11.9247 34.7941 15.615V23.9158V28.0758Z",
    fill: "#D7CEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6448 18.446H25.2696V16.074C25.2696 14.9647 24.3691 14.0654 23.2584 14.0654H20.472C19.3612 14.0654 18.4607 14.9646 18.4607 16.074V18.4459H16.0855C14.9747 18.4459 14.0742 19.3451 14.0742 20.4543V23.2368C14.0742 24.3461 14.9747 25.2453 16.0855 25.2453H18.4607V27.6172C18.4607 28.7264 19.3611 29.6257 20.472 29.6257H23.2584C24.3691 29.6257 25.2696 28.7264 25.2696 27.6172V25.2453H27.6448C28.7556 25.2453 29.656 24.3461 29.656 23.2368V20.4543C29.656 19.3452 28.7556 18.446 27.6448 18.446Z",
    fill: "#FFE0A7"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 13.457,
    y: 13.4512,
    width: 16.8125,
    height: 20.7896
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_0_7176_39779_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_7176_39779)",
    "data-figma-bg-blur-radius": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2566 30.2408H20.4703C19.0219 30.2408 17.8435 29.0642 17.8435 27.6177V25.8605H16.0838C14.6353 25.8605 13.457 24.6837 13.457 23.2372V20.4549C13.457 19.0084 14.6353 17.8316 16.0838 17.8316H17.8435V16.0743C17.8435 14.6278 19.0219 13.4512 20.4703 13.4512H23.2566C24.7051 13.4512 25.8834 14.6278 25.8834 16.0743V17.8315H27.6431C29.0916 17.8315 30.2699 19.0083 30.2699 20.4548V23.2372C30.2699 24.6836 29.0916 25.8604 27.6431 25.8604H25.8834V27.6176C25.8834 29.0642 24.7051 30.2408 23.2566 30.2408ZM16.0838 19.0609C15.3142 19.0609 14.6881 19.6861 14.6881 20.4548V23.2372C14.6881 24.0058 15.3142 24.631 16.0838 24.631H18.459C18.799 24.631 19.0745 24.9062 19.0745 25.2457V27.6176C19.0745 28.3861 19.7007 29.0114 20.4703 29.0114H23.2566C24.0262 29.0114 24.6523 28.3861 24.6523 27.6176V25.2457C24.6523 24.9062 24.9279 24.631 25.2679 24.631H27.6431C28.4127 24.631 29.0389 24.0058 29.0389 23.2372V20.4548C29.0389 19.6861 28.4127 19.0609 27.6431 19.0609H25.2679C24.9279 19.0609 24.6523 18.7857 24.6523 18.4462V16.0743C24.6523 15.3058 24.0262 14.6805 23.2566 14.6805H20.4703C19.7007 14.6805 19.0745 15.3058 19.0745 16.0743V18.4462C19.0745 18.7857 18.799 19.0609 18.459 19.0609H16.0838Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4724 45.8263C43.6159 43.6708 43.6745 43.548 43.6745 43.548L43.6587 43.5639C43.6587 43.5639 45.1728 42.0607 50.3957 36.7908C55.6188 31.5209 51.8766 25.2483 48.7524 22.1606C47.1449 20.5718 48.3031 21.7164 47.2715 20.6968C46.24 19.6773 43.2194 22.0927 40.9451 24.3669C38.6772 26.6347 38.3982 27.4723 39.4995 28.5142C39.4995 28.5142 39.4995 28.5142 41.3274 30.321C43.898 33.3511 42.2881 34.8211 38.6031 38.5392L38.591 38.5515C34.906 42.2697 33.4506 43.8926 30.3898 41.3569C27.8021 38.7993 28.5618 39.5502 28.5618 39.5502C27.517 38.5176 26.688 38.7523 24.4237 41.0367C22.1596 43.3211 19.7408 46.3655 20.7724 47.385C21.804 48.4045 20.646 47.26 22.2534 48.8487C25.3776 51.9365 31.6971 55.6084 36.9201 50.3384C37.555 49.6979 38.1353 49.1128 38.6648 48.579L41.4724 45.8263Z",
    fill: "#D6CDFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_7176_39779",
    x: 13.457,
    y: 13.4512,
    width: 16.8125,
    height: 20.7896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7176_39779"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7176_39779",
    result: "effect2_innerShadow_7176_39779"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7176_39779_clip_path",
    transform: "translate(-13.457 -13.4512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2566 30.2408H20.4703C19.0219 30.2408 17.8435 29.0642 17.8435 27.6177V25.8605H16.0838C14.6353 25.8605 13.457 24.6837 13.457 23.2372V20.4549C13.457 19.0084 14.6353 17.8316 16.0838 17.8316H17.8435V16.0743C17.8435 14.6278 19.0219 13.4512 20.4703 13.4512H23.2566C24.7051 13.4512 25.8834 14.6278 25.8834 16.0743V17.8315H27.6431C29.0916 17.8315 30.2699 19.0083 30.2699 20.4548V23.2372C30.2699 24.6836 29.0916 25.8604 27.6431 25.8604H25.8834V27.6176C25.8834 29.0642 24.7051 30.2408 23.2566 30.2408ZM16.0838 19.0609C15.3142 19.0609 14.6881 19.6861 14.6881 20.4548V23.2372C14.6881 24.0058 15.3142 24.631 16.0838 24.631H18.459C18.799 24.631 19.0745 24.9062 19.0745 25.2457V27.6176C19.0745 28.3861 19.7007 29.0114 20.4703 29.0114H23.2566C24.0262 29.0114 24.6523 28.3861 24.6523 27.6176V25.2457C24.6523 24.9062 24.9279 24.631 25.2679 24.631H27.6431C28.4127 24.631 29.0389 24.0058 29.0389 23.2372V20.4548C29.0389 19.6861 28.4127 19.0609 27.6431 19.0609H25.2679C24.9279 19.0609 24.6523 18.7857 24.6523 18.4462V16.0743C24.6523 15.3058 24.0262 14.6805 23.2566 14.6805H20.4703C19.7007 14.6805 19.0745 15.3058 19.0745 16.0743V18.4462C19.0745 18.7857 18.799 19.0609 18.459 19.0609H16.0838Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7176_39779",
    x1: 4.04037,
    y1: -10.7401,
    x2: 60.0881,
    y2: 36.4579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A33FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalService);
export default __webpack_public_path__ + "static/media/HospitalService.461b865490af93f5e14f3525759a5c00.svg";
export { ForwardRef as ReactComponent };